const HeroPoster = () => (
  <section className="gastro-care-banner video-banner">
    <img
      src="/assets/video/poster-desktop.webp"
      alt="Hospital Background"
      className="background-video desktop-video"
      fetchPriority="high"
      decoding="async"
    />
    <img
      src="/assets/video/poster-mobile.webp"
      alt="Hospital Background"
      className="background-video mobile-video"
      fetchPriority="high"
      decoding="async"
    />
  </section>
);

export default HeroPoster;
